jQuery(document).ready(function () {
    jQuery.fn.messageManager = function () {

        const ALERT_SUCCESS = 'alertSuccess',
            ALERT_INFO = 'alertInfo',
            ALERT_WARNING = 'alertWarning',
            ALERT_DANGER = 'alertDanger';

        const notificationTypesClasses = {
            alertSuccess: "alert alert-success",
            alertInfo: "alert alert-info",
            alertWarning: "alert alert-warning",
            alertDanger: "alert alert-danger"
        }

        const notificationContainer = "[data-notification-container]";

        var addMessage = function (messageText, messageType, autoRemove) {
            var message = '<p class="';
            switch (messageType) {
                case ALERT_SUCCESS:
                    message += notificationTypesClasses[ALERT_SUCCESS];
                    break;
                case ALERT_WARNING:
                    message += notificationTypesClasses[ALERT_WARNING];
                    break;
                case ALERT_DANGER:
                    message += notificationTypesClasses[ALERT_DANGER];
                    break;
                case ALERT_INFO:
                default:
                    message += notificationTypesClasses[ALERT_INFO];
                    break;
            }
            message += '">' + messageText + '</p>'
            jQuery(notificationContainer).append(message);
            if (autoRemove) {
                setTimeout(function(){
                    jQuery(notificationContainer).find("p").first().remove();
                }, 5000);
            }
        }

        return {
            addSuccess: function(message, autoRemove = false) {
                addMessage(message, ALERT_SUCCESS, autoRemove);
            },
            addNotice: function(message, autoRemove = false) {
                addMessage(message, ALERT_INFO, autoRemove);
            },
            addWarning: function(message, autoRemove = false) {
                addMessage(message, ALERT_WARNING, autoRemove);
            },
            addError: function(message, autoRemove = false) {
                addMessage(message, ALERT_DANGER, autoRemove);
            }
        }

    }
});